<script lang="ts">
  import { getContext } from "svelte"
  import { parseWidgets } from "website_script/lib/Parsers"
  import { getWidgetSelectors } from "website_script/lib/getWidgetSelectors"
  import InlineForm from "./InlineForm.svelte"
  import PriceAlertWidget from "./PriceAlertWidget.svelte"
  import SimilarCarsWidget from "./SimilarCarsWidget.svelte"
  import ModuleTypes from "../constants/ModuleTypes"
  import type { Settings } from "website_script/types/settings"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import ConversionBox from "./ConversionBox.svelte"
  import InlineButtons from "./InlineButtons.svelte"
  import PriceRatingWidgets from "./PriceRatingWidgets.svelte"
  import InlineWidget from "website_script/components/InlineWidget.svelte"

  // Fetch global settings and texts labels from context
  const settings = getContext<Settings>("settings")
  const {
    enableConversionBox,
    enableSimilarCarsWidget,
    enablePriceRatingWidget,
    selectorToAppendConversionBox,
    selectorToAppendPriceAlertWidget,
    selectorToAppendPriceRatingWidget,
    flowAvailability,
  } = settings
  const dealerTheme = getContext<DealerTheme>("dealerTheme")

  const customWidgetSelectors = {
    conversionBox: selectorToAppendConversionBox,
    priceAlertWidget: selectorToAppendPriceAlertWidget,
    priceRatingWidget: selectorToAppendPriceRatingWidget,
  }
  const widgets = parseWidgets(customWidgetSelectors)
  const widgetSelectors = getWidgetSelectors(customWidgetSelectors)
</script>

<!--
@component

Searches for occurrences of html classes defined in ../lib/getWidgetSelectors,
or in the website script rules interface.

On those classes we will append different inline widgets, dependent on the class.

This is done automatically for some inline widgets, but others needs to be enabled.
-->
<InlineButtons />

{#if enablePriceRatingWidget}
  <PriceRatingWidgets />
{/if}

{#each widgets as widget}
  <InlineWidget target={widget.elTarget} theme={dealerTheme}>
    {#if widget.selector === widgetSelectors.inlineForm && flowAvailability.trade_in}
      <InlineForm
        moduleType={ModuleTypes.TRADE_IN}
        elementData={widget.elData}
        on:flowEvent
      />
    {:else if widget.selector === widgetSelectors.bookTestDriveForm && flowAvailability.test_drive}
      <InlineForm
        moduleType={ModuleTypes.BOOK_TEST_DRIVE}
        elementData={widget.elData}
        on:flowEvent
      />
    {:else if enableConversionBox && widget.selector === widgetSelectors.conversionBox}
      <ConversionBox elementData={widget.elData} />
    {:else if enableSimilarCarsWidget && widget.selector === widgetSelectors.similarCarsWidget}
      <SimilarCarsWidget elementData={widget.elData} />
    {:else if widget.selector === widgetSelectors.priceAlertWidget && settings.car && settings.car.price}
      <PriceAlertWidget elementData={widget.elData} />
    {/if}
  </InlineWidget>
{/each}
